// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__3AcOp","table":"Market_table__1Odct","row":"Market_row__1_cNh","col":"Market_col__2vrmc","foot":"Market_foot__lNATB","arrow":"Market_arrow__2sSpa"};